import React from 'react';
import Hero from '../components/Hero';
import TodaysBlog from '../components/TodaysBlog';
import AboutUs from '../components/AboutUs';
import Services from '../components/Services';
import OurTeam from '../components/OurTeam';

export default function Home() {
  return (
    <main>
      <Hero />
      <TodaysBlog />
      <AboutUs />
      <Services />
      <OurTeam />
    </main>
  );
}
